/* eslint-disable @typescript-eslint/default-param-last */
import { CONFIGURATION_SET } from './actions';

const initialState = {
  done: false,
  data: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIGURATION_SET:
      return {
        ...state,
        done: true,
        data: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
